import {observer} from "mobx-react-lite";
import {useStores} from "../../../stores";
import React from "react";
import {Button, CircularProgress, Grid, Typography} from "@mui/material";
import {UploadFile} from "@mui/icons-material";
import NoData from '../NoData.svg?react';
import {environment} from "../../../env";
import {ContractUploadComponent} from "./ContractUploadComponent";
import {CONTRACT_DEMO_DATA} from "../data/ContractDemoData";

export const ContractEmptyComponent: React.FC = observer(() => {
    const {contractInsightsStore, authStore} = useStores();
    const className = 'contract-upload-page'

    const [demoIsLoading, setDemoIsLoading] = React.useState(false);

    return (
        <Grid container className={className} alignItems="center" justifyContent="center" direction="column">
            <Grid>
                <NoData/>
            </Grid>

            <Grid style={{marginTop: '3em', marginBottom: '3em'}}>
                <Typography variant="h5" className="mb-2">
                    It’s all empty here...
                </Typography>
                {environment.isDemo && <Typography variant="body1" className="mb-2">
                    To start, try to upload or drag and drop a contract file here
                </Typography>}
            </Grid>

            <Grid>
                {environment.isDemo
                    ? <Button
                        disabled={demoIsLoading || !authStore.hasEditPermission}
                        startIcon={demoIsLoading ? <CircularProgress size={20}/> : <UploadFile/>}
                        variant="outlined"
                        component="label"
                        className="upload-file-button">
                        Upload contract file
                        <input
                            hidden
                            accept="application/pdf"
                            type="file"
                            onChange={() => {
                                //fake call
                                setDemoIsLoading(true);
                                setTimeout(() => {
                                    setDemoIsLoading(false);
                                    contractInsightsStore.setContractsData(CONTRACT_DEMO_DATA);
                                    console.log("Fake API call completed.");
                                }, 3000);
                            }}
                        />
                    </Button>
                    : <ContractUploadComponent/>
                }
            </Grid>

        </Grid>
    );
});
